module.exports = __webpack_public_path__ + "static/img/05_eee_cornelius_carstens.cdacb0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/eee/05_eee_cornelius_carstens.jpg
// module id = rkbd
// module chunks = 1